import * as React from "react";
import { Stack, Typography } from "@mui/material";
import ContentVerification from "../../Components/organisms/PublicVerification/ContentVerification";

const PublicVerification = () => {
  return (
    <Stack direction={"column"}>
      <Typography>
          <>
            <ContentVerification />
          </>  
      </Typography>
    </Stack>
  );
};

export default PublicVerification;
